import { Inject, Injectable } from "@angular/core";
import { DwDataItemKeyValues, DwDataRequest, DwDatasource, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwOrmDataSource, DwQuery, DwSecurityUserService } from "@devwareapps/devware-cap";
import { AppMetaData, AppMetaDataItemNames } from "../../../meta-data/app-meta-data.service";
import { Observable } from "rxjs";

@DwDatasource({
    keyName: 'FlightSchoolApplicantFormDataSource',
    display: 'Applicant Form data Source',
    itemName: AppMetaDataItemNames.FlightSchoolApplicant,
})
@Injectable()
export class FlightSchoolApplicantFormDataSourceService extends DwOrmDataSource {

    constructor(
        @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) metaDataService: DwMetaDataService,
        private securityUserService: DwSecurityUserService,
    ) {
        super(dwOrmDataService, metaDataService, AppMetaDataItemNames.PlanOfAction);
    }

    initDataSource() {
        
    }
    
    loadItemFromQuery(query: DwQuery, keyValues: DwDataItemKeyValues | number): Observable<any> {

        const applicantQueuy = AppMetaData.FlightSchoolApplicant.CreateQueryBuilder(query);

        const acsWrittenResultQuery = AppMetaData.ApplicantAcsWrittenResult.CreateQueryBuilder();

        acsWrittenResultQuery.addPrefetch(r => r.ApplicantAcsWrittenResultMissedCode);

        let prefetchWrittenResult = query.Prefetch.find(p => p.RelationName === AppMetaData.FlightSchoolApplicant.Relations.ApplicantAcsWrittenResult.relationName);

        if (!prefetchWrittenResult) {
            applicantQueuy.addPrefetch(r => r.ApplicantAcsWrittenResult, acsWrittenResultQuery.query);

            prefetchWrittenResult = query.Prefetch.find(p => p.RelationName === AppMetaData.FlightSchoolApplicant.Relations.ApplicantAcsWrittenResult.relationName);
        }

        prefetchWrittenResult.Query = acsWrittenResultQuery.query;


        return super.loadItemFromQuery(applicantQueuy.query, keyValues);
    }

   
    // prepareRequestQuery(request: DwDataRequest): DwQuery {
    //     const baseQuery = super.prepareRequestQuery(request);

    // }

}